import React from 'react';
import { Link } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import payment_error from '../assets/images/payment_error.png';
import EDSFooter from '../components/EDSFooter';

const KartaPlatniczaError = () => {
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <ProfileHeader></ProfileHeader>
                <div className="half-half half-half--text-to-left">
                    <main className="">
                        <div>
                            <section className="margin-top-64 margin-bottom-32">
                                <div className="row-align-items-center">
                                    <svg
                                        className="credit-card-icon"
                                        viewBox="0 0 28 28"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M2.33334 8.16602C2.33334 7.23776 2.70209 6.34752 3.35847 5.69114C4.01485 5.03476 4.90509 4.66602 5.83334 4.66602H22.1667C23.0949 4.66602 23.9852 5.03476 24.6416 5.69114C25.2979 6.34752 25.6667 7.23776 25.6667 8.16602V19.8327C25.6667 20.7609 25.2979 21.6512 24.6416 22.3076C23.9852 22.9639 23.0949 23.3327 22.1667 23.3327H5.83334C4.90509 23.3327 4.01485 22.9639 3.35847 22.3076C2.70209 21.6512 2.33334 20.7609 2.33334 19.8327V8.16602ZM5.83334 6.99935C5.52392 6.99935 5.22718 7.12227 5.00839 7.34106C4.78959 7.55985 4.66668 7.8566 4.66668 8.16602V9.33268H23.3333V8.16602C23.3333 7.8566 23.2104 7.55985 22.9916 7.34106C22.7728 7.12227 22.4761 6.99935 22.1667 6.99935H5.83334ZM23.3333 11.666H4.66668V19.8327C4.66668 20.1421 4.78959 20.4388 5.00839 20.6576C5.22718 20.8764 5.52392 20.9993 5.83334 20.9993H22.1667C22.4761 20.9993 22.7728 20.8764 22.9916 20.6576C23.2104 20.4388 23.3333 20.1421 23.3333 19.8327V11.666ZM7.00001 15.166C7.00001 14.8566 7.12293 14.5598 7.34172 14.3411C7.56051 14.1223 7.85726 13.9993 8.16668 13.9993H14C14.3094 13.9993 14.6062 14.1223 14.825 14.3411C15.0438 14.5598 15.1667 14.8566 15.1667 15.166C15.1667 15.4754 15.0438 15.7722 14.825 15.991C14.6062 16.2098 14.3094 16.3327 14 16.3327H8.16668C7.85726 16.3327 7.56051 16.2098 7.34172 15.991C7.12293 15.7722 7.00001 15.4754 7.00001 15.166Z" />
                                    </svg>
                                    <h2 className="h2">Karta płatnicza</h2>
                                </div>
                                <p className="margin-top-32 text-large">
                                    Wystąpił problem podczas rejestrowania karty płatniczej.
                                </p>
                                <p className="margin-top-32">
                                    Spróbuj ponownie lub skontaktuj się z BOK.
                                </p>

                                <Link to="/wybor_opcji_4_forma_platnosci">
                                    <a href="" className="btn-primary-responsive margin-top-64">
                                        wróć
                                    </a>
                                </Link>

                                <h2 className="h2 margin-top-64">INFOLINIA</h2>
                                <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                                <p>w godzinach 9:00 - 17:00</p>
                                <p className="margin-top-16">tel.: 601 20 20 20</p>
                                <p>e-mail: studio@egurrola.pl</p>
                                <a
                                    href=""
                                    className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-64"
                                >
                                    Wróć do strony głównej
                                </a>
                            </section>
                        </div>
                    </main>
                    <div className="decorative">
                        <img
                            src={payment_error}
                            alt="Płatność nieudana"
                            className="decorative__img"
                        />
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default KartaPlatniczaError;
